import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { DatePicker, Popconfirm, Table } from "antd";
import { Edit, Trash2 } from "feather-icons-react/build/IconComponents";
import { Calendar, Info } from "feather-icons-react/build/IconComponents";
import { Controller, useForm } from "react-hook-form";
import InputField from "../../components/Input";
import dayjs from "dayjs";
import BrandServices from "../../../services/Brand";
import ProductServices from "../../../services/Product";
import SizeServices from "../../../services/Size";
import { v4 as uuidv4 } from 'uuid'
import { useSelector } from "react-redux";
import SelectField from "../../components/Select";
import SupplierServices from "../../../services/Supplier";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import StoreServices from "../../../services/Store";
import { DateFormat } from "../../../utils";

const Form = ({ onSubmit, loading }) => {

  const route = all_routes;
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();

  const { userData } = useSelector((state) => {
    return {
      userData: state.user_data
    }
  });

  const { register, handleSubmit, formState: { errors }, control, setValue } = useForm();
  const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, reset: reset2, setValue: setValue2 } = useForm();
  const { register: register3, handleSubmit: handleSubmit3, formState: { errors: errors3 }, reset: reset3, setValue: setValue3 } = useForm();

  // *For Update Invoice Row
  const [updateData, setUpdateData] = useState();

  // *For Store
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);

  // *For Supplier
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  // *For Brands
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);

  // *For Products
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // *For Sizes
  const [sizes, setSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);

  // *For Invoice Rows
  const [invoiceRows, setInvoiceRows] = useState([]);
  const [total, setTotal] = useState(0);

  // *For Get Suppliers
  const getSuppliers = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await SupplierServices.getSuppliers(params)
      setSuppliers(data)
    } catch (error) {
      console.log('getSuppliers => error:', error)
    }
  }

  // *For Get Store
  const getStores = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await StoreServices.getStores(params)
      setStores(data)
    } catch (error) {
      console.log('getStores => error:', error)
    }
  }

  // *For Get Brands
  const getBrands = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await BrandServices.getBrands(params)
      setBrands(data)
    } catch (error) {
      console.log('getBrands => error:', error)
    }
  }

  // *For Get Products
  const getProducts = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await ProductServices.getProducts(params)
      setProducts(data)
    } catch (error) {
      console.log('getProducts => error:', error)
    }
  }

  // *For Get Sizes
  const getSizes = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await SizeServices.getSizes(params)
      setSizes(data)
    } catch (error) {
      console.log('getSizes => error:', error)
    }
  }

  // *For Submit Form
  const submitForm = async (formData) => {
    try {
      // console.log('formData:', formData)
      // const salePersonIds = []
      // const invoicePayment = []
      const invoiceItems = []
      invoiceRows.forEach(e => {
        let item = {
          brand_id: e?.brand?.id,
          itemId: e?.product?.id,
          size_id: e?.size?.id,
          quantity: e?.quantity,
          unitPrice: e?.purchasePrice,
          totalPrice: e?.extendedTotal,
        }
        invoiceItems.push(item)
      })
      // selectedSalePerson.forEach(e => {
      //   salePersonIds.push(e?.id)
      // })
      // if (selectedPaymentMethod1?.id && receivedAmount1) {
      //   let pay1 = {
      //     payment_head_id: selectedPaymentMethod1?.id,
      //     received_amount: receivedAmount1
      //   }
      //   invoicePayment.push(pay1)
      // }
      // if (selectedPaymentMethod2?.id && receivedAmount2) {
      //   let pay2 = {
      //     payment_head_id: selectedPaymentMethod2?.id,
      //     received_amount: receivedAmount2
      //   }
      //   invoicePayment.push(pay2)
      // }
      // if (selectedPaymentMethod3?.id && receivedAmount3) {
      //   let pay3 = {
      //     payment_head_id: selectedPaymentMethod3?.id,
      //     received_amount: receivedAmount3
      //   }
      //   invoicePayment.push(pay3)
      // }
      let obj = {
        store_id: userData?.store?.id,
        invoiceRef: formData?.invoiceRef,
        purchaseDate: formData?.invoice_date,
        dueDate: formData?.invoice_due_date,
        supplier_id: selectedSupplier?.id,
        remarks: formData?.remarks,
        items: invoiceItems,
        documents: []
      }
      //   billing_name: formData?.billingName,
      //   billing_address: formData?.billingAddress,
      //   billing_phone_number_one: formData?.billingPhone1,
      //   billing_phone_number_two: formData?.billingName2,
      //   billing_email: formData?.billingEmail,
      //   shipping_name: formData?.shippingName,
      //   shipping_address: formData?.shippingAddress,
      //   shipping_phone_number_one: formData?.shippingPhone1,
      //   shipping_phone_number_two: formData?.shippingPhone2,
      //   shipping_email: formData?.shippingEmail,
      //   same_delivery_details: sameDeliveryAddress,
      //   order_date: formData?.order_date,
      //   delivery_date: formData?.delivery_date,
      //   delivery_time_slot_id: selectedDeliveryTimeSlot?.id,
      //   delivery_day: dayjs(formData?.delivery_date).format('dddd'),
      //   delivery_type_id: selectedDeliveryType?.id,
      //   salespersons: salePersonIds,
      //   sale_invoice_items: invoiceItems,
      //   delivery_charges: selectedServiceType?.price,
      //   total: total,
      //   total_savings: total - totalRegPrice,
      //   sub_total: subTotal,
      //   sales_tax: saleTaxRate,
      //   total_sale: subTotal + saleTaxRate,
      //   balance_amount: (subTotal + saleTaxRate) - (parseInt(receivedAmount1) + parseInt(receivedAmount2) + parseInt(receivedAmount3)),
      //   comments: formData?.comment,
      //   instructions: formData?.instructions,
      //   invoice_payments: invoicePayment
      // }
      // console.log(obj)
      onSubmit(obj)
    } catch (error) {
      console.log('submitForm => error:', error)
    }
  }

  // *For Submit Invoice Row
  const submitInvoiceRow = async (formData) => {
    try {
      let obj = {
        brand: selectedBrand,
        product: selectedProduct,
        size: selectedSize,
        description: formData?.description,
        quantity: parseInt(formData?.quantity),
        purchasePrice: parseFloat(formData?.purchasePrice),
        extendedTotal: parseFloat(formData?.purchasePrice) * parseInt(formData?.quantity),
      }
      if (updateData?.id) {
        const index = invoiceRows.findIndex((e) => e.id === updateData?.id)

        if (index !== -1) {
          const updatedInvoiceRows = [...invoiceRows];
          updatedInvoiceRows[index] = { ...updatedInvoiceRows[index], ...obj };
          setInvoiceRows(updatedInvoiceRows);
        }

      } else {
        const updateInvoiceRow = [...invoiceRows]
        updateInvoiceRow.push({ id: uuidv4(), ...obj })
        setInvoiceRows(updateInvoiceRow)
      }
      reset2();
      setSelectedBrand(null)
      setSelectedProduct(null)
      setSelectedSize(null)
      const btn = document.getElementById('modalClose')
      btn.click();
    } catch (error) {
      console.log('submitForm => error:', error)
    }
  }

  // *For Delete Row
  const deleteInvoiceRow = (id) => {
    try {
      const index = invoiceRows.findIndex((e) => e.id === id)
      let updateInvoiceRow = [...invoiceRows]
      updateInvoiceRow.splice(index, 1);
      setInvoiceRows(updateInvoiceRow)
    } catch (error) {
      console.log('deleteRow => error:', error)
    }
  }

  const columns = [
    {
      title: "Brand",
      dataIndex: "brand",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Product",
      dataIndex: "product",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Size",
      dataIndex: "size",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Purchase Price",
      dataIndex: "purchasePrice",
      render: (text) => (
        <span>
          ${text}
        </span>
      ),
    },
    {
      title: "Extended Total",
      dataIndex: "extendedTotal",
      render: (text) => (
        <span>
          ${text}
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            <Link className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#open-modal"
              onClick={() => setUpdateData(record)}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link className="confirm-text p-2">
              <Popconfirm title="Sure to delete?" onConfirm={() => deleteInvoiceRow(record.key)}>
                <Trash2 className="feather-trash-2" />
              </Popconfirm>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  // *For Get Purchase Invoice Details
  const getPurchaseInvoiceDetails = async () => {
    try {
      // const { data } = await PurchaseInvoiceServices.getPurchaseInvoiceById(id)
      const data = state
      setInvoiceRows(data?.purchase_invoice_items)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Create Brand
  const createBrand = async (name) => {
    try {
      let obj = {
        name: name,
        remarks: "",
        is_active: true
      }
      const { data } = await BrandServices.createBrand(obj)
      getBrands()
      setSelectedBrand({ id: data[0].id, name: data[0].name });
      setValue("brand", data[0].name);
    } catch (error) {
      console.log('createBrand => error:', error)
    }
  }

  // *For Create Product
  const createProduct = async (name) => {
    try {
      let obj = {
        name: name,
        price: 1,
        quantity: 1,
        remarks: "",
        code: " ",
        spiff: 0,
        brand_id: 1,
        category_id: 1,
        bay_id: 1,
        section_id: 1,
        is_active: true,
      }
      const { data } = await ProductServices.createProduct(obj)
      getProducts()
      setSelectedProduct({ id: data[0].id, name: data[0].name });
      setValue("product", data[0].name);
    } catch (error) {
      console.log('createProduct => error:', error)
    }
  }

  // *For Create Size
  const createSize = async (name) => {
    try {
      let obj = {
        name: name,
        remarks: "",
        is_active: true
      }
      const { data } = await SizeServices.createSize(obj)
      getSizes()
      setSelectedSize({ id: data[0].id, name: data[0].name });
      setValue("size", data[0].name);
    } catch (error) {
      console.log('createSize => error:', error)
    }
  }

  const getProductByBarcode = async (formData) => {
    try {

    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    getSuppliers()
    getBrands()
    getProducts()
    getSizes()
    getStores()
  }, []);

  useEffect(() => {
    const invoiceTotal = invoiceRows.reduce((acc, item) => acc + (item?.extendedTotal ? item?.extendedTotal : 0), 0)
    setTotal(invoiceTotal || 0)
  }, [invoiceRows]);

  useEffect(() => {
    if (updateData) {
      setValue2('brand', updateData?.brand?.name)
      setValue2('product', updateData?.product?.name)
      setValue2('size', updateData?.size?.name)
      setValue2('description', updateData?.description)
      setValue2('quantity', updateData?.quantity)
      setValue2('purchasePrice', updateData?.purchasePrice)
      setSelectedBrand(updateData?.brand)
      setSelectedProduct(updateData?.product)
      setSelectedSize(updateData?.size)
    }
  }, [updateData]);

  useEffect(() => {
    if (id) {
      // getPurchaseInvoiceDetails()
    }
  }, [id]);

  return (
    <>
      <div className="modal fade" id="open-modal">
        <div className="modal-dialog modal-dialog-centered custom-modal-two" style={{ maxWidth: '600px' }}>
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{updateData?.id ? "Update Item" : "Create Item"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body new-employee-field">
                  <form onSubmit={handleSubmit2(submitInvoiceRow)}>
                    <div className="row">
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3">
                          <SelectField
                            addNew={(newValue) => createBrand(newValue)}
                            label={"Brand"}
                            options={brands}
                            selected={selectedBrand}
                            onSelect={(value) => setSelectedBrand(value)}
                            error={errors2?.brand?.message}
                            register={register2("brand", {
                              required: 'Please select brand.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-8 col-sm-6 col-12">
                        <div className="mb-3">
                          <SelectField
                            addNew={(newValue) => createProduct(newValue)}
                            label={"Product"}
                            options={products}
                            selected={selectedProduct}
                            onSelect={(value) => setSelectedProduct(value)}
                            error={errors2?.product?.message}
                            register={register2("product", {
                              required: 'Please select product.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3">
                          <InputField
                            label="Quantity"
                            error={errors2?.quantity?.message}
                            register={register2("quantity", {
                              required: 'Please enter quantity.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3">
                          <SelectField
                            addNew={(newValue) => createSize(newValue)}
                            label={"Size"}
                            options={sizes}
                            selected={selectedSize}
                            onSelect={(value) => setSelectedSize(value)}
                            error={errors2?.size?.message}
                            register={register2("size", {
                              required: 'Please select size.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3">
                          <InputField
                            label="Purchase Price"
                            error={errors2?.purchasePrice?.message}
                            register={register2("purchasePrice", {
                              required: 'Please enter purchase price.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-7 col-sm-12 col-12">
                        <div className="mb-3">
                          <InputField
                            label="Description"
                            inputType="textarea"
                            placeholder="Type Description"
                            register={register2("description")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        id="modalClose"
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-submit"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit(submitForm)}>
        <div className="card">
          <div className="card-body add-product pb-0" style={{ padding: '1rem' }}>

            {/* Information & Billing & Shipping Details */}
            <div className="mb-2">
              <div className="addproduct-icon" style={{ paddingBottom: '10px', marginBottom: '10px' }}>
                <h5>
                  <Info className="add-info" />
                  <span>Information</span>
                </h5>
              </div>
              <div className="row">
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <div className="mb-1 add-product">
                    <InputField
                      label="Invoice Ref."
                      type="text"
                      register={register("invoiceRef")}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <div className="mb-1 add-product">
                    <div className="input-blocks mb-0">
                      <label className="form-label">Invoice Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <Controller
                          name="invoice_date"
                          control={control}
                          render={({ field: { onChange, onBlur, value, ref } }) => (
                            <DatePicker
                              className="datetimepicker"
                              placeholder="Invoice Date"
                              format={DateFormat}
                              minDate={dayjs()}
                              onChange={(date) => onChange(date || null)}
                              onBlur={onBlur}
                              value={value ? dayjs(value, DateFormat) : null}
                              ref={ref}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <div className="mb-1 add-product">
                    <div className="input-blocks mb-0">
                      <label className="form-label">Invoice Due Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <Controller
                          name="invoice_due_date"
                          control={control}
                          render={({ field: { onChange, onBlur, value, ref } }) => (
                            <DatePicker
                              className="datetimepicker"
                              placeholder="Invoice Due Date"
                              format={DateFormat}
                              minDate={dayjs()}
                              onChange={(date) => onChange(date || null)}
                              onBlur={onBlur}
                              value={value ? dayjs(value, DateFormat) : null}
                              ref={ref}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <div className="mb-1 add-product">
                    <SelectField
                      label={"Supplier"}
                      options={suppliers}
                      selected={selectedSupplier}
                      onSelect={(value) => setSelectedSupplier(value)}
                      error={errors?.supplier?.message}
                      register={register("supplier", {
                        required: 'Please select supplier.'
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <div className="mb-1 add-product">
                    <SelectField
                      label={"Store"}
                      options={stores}
                      selected={selectedStore}
                      onSelect={(value) => setSelectedStore(value)}
                      error={errors?.store?.message}
                      register={register("store", {
                        required: 'Please select store.'
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-6 my-2">
                  <div className="mb-1 add-product">
                    <div className="input-blocks mb-0">
                      <div className="input-groupicon calender-input">
                        <InputField
                          label="Remarks"
                          inputType="textarea"
                          placeholder="Type Remarks"
                          register={register("remarks")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-6 my-2">
                  <div className="input-blocks image-upload-down">
                    <label> Upload Invoice PDF File</label>
                    <div className="image-upload download">
                      <input type="file" style={{ height: '100px' }} />
                      <div className="image-uploads">
                        <ImageWithBasePath src="assets/img/download-img.png" alt="img" style={{ height: "50px" }} />
                        <h4>
                          Drag and drop a <span>file to upload</span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sale */}
            <div className="mb-2">
              <div className="addproduct-icon" style={{ paddingBottom: '10px', marginBottom: '10px' }}>
              </div>
              <div className="row">
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <div className="mb-1 add-product">
                    <InputField
                      placeholder="Scan here"
                      type="text"
                      error={errors3?.barcode?.message}
                      register={register3("barcode", {
                        required: 'Please enter sku/barcode.',
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <button type="button"
                    className="btn btn-submit me-2"
                    onClick={handleSubmit3(getProductByBarcode)}
                  // data-bs-toggle="modal"
                  // data-bs-target="#open-modal"
                  >
                    Search
                  </button>
                  <button type="button"
                    className="btn btn-info"
                    data-bs-toggle="modal"
                    data-bs-target="#open-modal"
                  >
                    Add Manual
                  </button>
                </div>
              </div>

              <Table
                className="table datanew dataTable no-footer custom-table"
                columns={columns}
                dataSource={invoiceRows}
                pagination={false}
              />

              {/* <div className="row mt-3 mb-1">
                <div className="col-lg-3 col-sm-6 col-12">
                  <button type="button"
                    className="btn btn-submit"
                    data-bs-toggle="modal"
                    data-bs-target="#open-modal"
                  >
                    Add Item
                  </button>
                </div>
              </div> */}
              <div className="row">
                <div className="col-lg-4">
                </div>
                <div className="col-lg-6 ms-auto">
                  <div className="total-order w-100 max-widthauto m-auto mb-4">
                    <ul>
                      <li>
                        <h4>Total</h4>
                        <h5>$ {parseFloat(total)}</h5>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="col-lg-12">
          <div className="btn-addproduct mb-4">
            <Link to={route.sales} className="btn btn-cancel me-2">
              Cancel
            </Link>
            <button
              type="submit"
              className="btn btn-submit"
              disabled={loading}
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Form;
